import React, { useState, useRef } from "react";
import { FaPlayCircle } from "react-icons/fa";
import { Controller, useForm } from "react-hook-form";

const ClassSessions = ({ liveClassDoc }) => {
  const [showForm, setShowForm] = useState(false);
  const [currentClass, setCurrentClass] = useState(null);
  const formRef = useRef(null);
  const role = localStorage.getItem("role");

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();

  const allowedRegionsList = ["Region 1", "Region 2", "Region 3"]; // Define your regions here

  // Populate form with selected live class data
  const handleEditClick = (liveClass) => {
    setCurrentClass(liveClass);
    setShowForm(true);

    setValue("title", liveClass.title);
    setValue("description", liveClass.description);
    setValue("startDate", liveClass.startDate);
    setValue("endDate", liveClass.endDate);
    setValue("allowedRegions", liveClass.allowedRegions || []);

    setTimeout(() => {
      formRef.current?.scrollIntoView({
        top: formRef.current?.offsetTop,
        behavior: "smooth",
      });
    }, 100);
  };

  const onSubmit = (data) => {
    console.log("Updating class", {
      id: currentClass.id,
      ...data,
    });
    setShowForm(false);
    reset();
  };

  return (
    <div className="container my-5">
      <h3 className="mb-4">Live Classes</h3>

      {showForm && (
        <div ref={formRef} className="row h-auto my-5">
          <div className="col">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group">
                <label>Class Title</label>
                <Controller
                  name="title"
                  control={control}
                  render={({ field }) => (
                    <input
                      className={`form-control ${
                        errors?.title ? "error-input" : ""
                      }`}
                      type="text"
                      {...field}
                    />
                  )}
                />
              </div>
              <div className="form-group">
                <label>Class Description</label>
                <Controller
                  name="description"
                  control={control}
                  render={({ field }) => (
                    <input
                      className={`form-control ${
                        errors?.description ? "error-input" : ""
                      }`}
                      type="text"
                      {...field}
                    />
                  )}
                />
              </div>
              <div className="form-group">
                <label>Start Date</label>
                <Controller
                  name="startDate"
                  control={control}
                  render={({ field }) => (
                    <input type="date" className="form-control" {...field} />
                  )}
                />
              </div>
              <div className="form-group">
                <label>End Date</label>
                <Controller
                  name="endDate"
                  control={control}
                  render={({ field }) => (
                    <input type="date" className="form-control" {...field} />
                  )}
                />
              </div>
              <div className="form-group">
                <label>Allowed Regions</label>
                <Controller
                  name="allowedRegions"
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <div>
                      {allowedRegionsList.map((region) => (
                        <div key={region} className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            value={region}
                            checked={value.includes(region)}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              if (checked) {
                                onChange([...value, region]);
                              } else {
                                onChange(value.filter((r) => r !== region));
                              }
                            }}
                          />
                          <label className="form-check-label">{region}</label>
                        </div>
                      ))}
                    </div>
                  )}
                />
              </div>
              <button type="submit" className="btn btn-success me-5">
                Update Class
              </button>
              <button
                className="btn btn-outline-secondary"
                onClick={() => setShowForm(false)}
              >
                Close Form
              </button>
            </form>
          </div>
        </div>
      )}
      <div className="d-flex flex-wrap">
        {liveClassDoc &&
          liveClassDoc.map((liveClass) => (
            <div
              key={liveClass.id}
              className="col-12 col-md-6 col-lg-4 d-flex mb-4 mx-2"
            >
              <div className="card flex-fill shadow-sm">
                <div className="card-body d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="card-title mb-0">{liveClass.title}</h5>
                    <span className="badge bg-success d-flex align-items-center">
                      <FaPlayCircle className="me-1" /> Live
                    </span>
                  </div>
                  <p className="card-text mb-1">
                    <strong>Teacher:</strong> {liveClass.teacher || "teacher"}
                  </p>
                  <p className="card-text mb-3">
                    <strong>Time:</strong> {liveClass.startDate}
                  </p>
                  <a
                    href={liveClass.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary mb-3"
                  >
                    Join Now
                  </a>
                  {role === "admin" && (
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => handleEditClick(liveClass)}
                    >
                      Edit Class
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ClassSessions;
